export const AdminConfig = {
  COUNT_CREATE_ALL_LABELS: 10,
  COUNT_PRINT_ALL_LABELS: 500,
  PAGE_SIZE_LOAD_MORE: 200,
  SUPPORTED_FORMATS: ['text/csv'],
}
